<template>
  <div class="home data-panel-home guide-home">
    <Header title="教程引导"></Header>
    <div
      v-if="!firstPanel && !secondPanel && !fourthPanel && !thirdPanel"
      class="guide-content"
    >
      <div class="guide-detail-content">请确认您的资源类型</div>
      <div
        class="guide-choose-type guide-tab"
        :closable="false"
        @click="firstPanel = true"
        type="info"
      >1.路由器设备，通过提供公网IP进行网络任务。
      </div>
      <div
        class="guide-choose-type guide-tab"
        :closable="false"
        @click="secondPanel = true"
        type="info"
      >2.ARM盒子（N1/我家云/电视盒子）通过提供上行带宽进行计算任务。
      </div>
      <div
        class="guide-choose-type guide-tab"
        :closable="false"
        @click="thirdPanel = true"
        type="info"
      >
        3.X86盒子（蜗牛星际等）/虚拟机通过提供上行带宽进行计算任务。
      </div>
      <div
        class="guide-choose-type guide-tab"
        :closable="false"
        @click="fourthPanel = true"
        type="info"
      >
        4.高配服务器物理机通过汇聚3G以上带宽或专线进行标准节点任务。
      </div>
    </div>
    <div
      v-if="!firstPanel && !secondPanel && !fourthPanel && !thirdPanel"
      class="guide-bottom"
    >
      开始刷机前，请先前往 https://bonuscloud.net/ 注册账号并获取激活设备用的 Bcode，按照后续教程安装镜像并绑定至账号即可。
    </div>
    <div
      v-if="firstPanel"
      class="first-panel"
    >
      <el-collapse
        v-model="activeNames"
        @change="handleChange"
      >
        <el-collapse-item
          title="1. (推荐) 斐讯K2/优酷路由宝/新路由3定制版固件 (已更新至13P版本)"
          name="1"
        >
          <div>查看教程：<a
              class="bonus-color"
              href="https://bonuscloud.club/viewtopic.php?f=49&t=830"
            >viewtopic.php?f=49&t=830</a></div>
          <div class="margin-top-20">
            注：所有可以刷Breed的MT7620及MT7621系列路由器均可使用本固件
          </div>
          <div>
            <ul class="first-ul">
              <li>MT7620处理器+64M内存设备使用K2固件，例如：</li>
              <ul class="second-ul">
                <li>K1、K1S、K2、K2C、K2G(可能千兆口无法驱动)</li>
                <li>小米mini(支持5G无线，但是只支持64M内存)</li>
                <li>袋鼠云(支持5G无线，但是只支持64M内存)</li>
                <li>极路由3(支持5G无线，但是只支持64M内存，千兆口可能无法驱动)</li>
              </ul>
              <li>MT7620处理器+128M内存设备使用路由宝固件，例如：</li>
              <ul class="second-ul">
                <li>极路由1s(仅支持HC5661，HC5661A不支持)</li>
                <li>极路由2(不带5G无线，支持128M内存)</li>
                <li>极路由3(不带5G无线，千兆口可能无法驱动，支持128M内存)</li>
                <li>袋鼠云(不带5G无线，支持128M内存)</li>
                <li>小米路由mini(不带5G无线，但是USB和SD卡可用，支持128M内存)</li>
              </ul>
              <li>MT7621处理器+512M内存设备使用新路由3固件，例如：</li>
              <ul class="second-ul">
                <li>新路由3</li>
                <li>极歌华链</li>
                <li>小娱C5</li>
              </ul>
            </ul>
          </div>
        </el-collapse-item>
        <el-collapse-item
          title="2. 梅林固件目前暂不支持"
          name="2"
        >
          <div>由于梅林依赖问题，梅林系统暂无法使用。</div>
        </el-collapse-item>
        <el-collapse-item
          title="3. x86脚本单安装网络任务教程（支持多开）"
          name="3"
        >
          <div>支持设备：x86架构电脑、服务器等，包括蜗牛星际等基于x86架构的矿机</div>
          <div>查看教程：<a
              class="bonus-color"
              href="https://bonuscloud.club/viewtopic.php?f=52&t=5446"
            >viewtopic.php?f=52&t=5446</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="4. N1脚本单安装网络任务教程（支持多开）"
          name="4"
        >
          <div>支持设备：斐讯N1</div>
          <div>查看教程：<a
              class="bonus-color"
              href="https://bonuscloud.club/viewtopic.php?f=51&t=5487"
            >viewtopic.php?f=51&t=5487</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="5. MT7621系列路由器带博纳云插件OpenWrt固件"
          name="5"
        >
          <div>支持设备：K2P、新路由3、极路由B70等</div>
          <div>查看教程：<a
              class="bonus-color"
              href="https://bonuscloud.club/viewtopic.php?f=27&t=2051"
            >viewtopic.php?f=27&t=2051</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="6. MT7620系列路由器带博纳云插件OpenWrt固件"
          name="6"
        >
          <div>支持设备：路由宝、小米mini、极路由1s/2/3等</div>
          <div>查看教程：<a
              class="bonus-color"
              href="https://bonuscloud.club/viewtopic.php?f=27&t=2038"
            >viewtopic.php?f=27&t=2038</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="7. 集成博纳云依赖OpenWrt固件"
          name="7"
        >
          <div>支持设备：新3/hc5661/hc5661a/路由宝/3800等</div>
          <div>查看教程：<a
              class="bonus-color"
              href="https://bonuscloud.club/viewtopic.php?t=2043"
            >viewtopic.php?t=2043</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="8. OpenWrt手动安装"
          name="8"
        >
          <div>查看教程：</div>
          <div>OpenWrt 官方固件下载（请下载18.06.1版本）：<a
              class="bonus-color"
              href="https://downloads.openwrt.org/releases/18.06.1/targets/"
            >https://downloads.openwrt.org/releases/18.06.1/targets/</a></div>
          <div class="margin-top-20">OpenWrt 插件一键安装教程：<a
              class="bonus-color"
              href="https://bonuscloud.club/viewtopic.php?f=27&t=956"
            >viewtopic.php?f=27&t=956</a></div>
        </el-collapse-item>
      </el-collapse>

    </div>
    <div
      v-if="secondPanel"
      class="first-panel"
    >
      <div class="margin-top-20">
        根据自己的设备实际情况选择。注：
        <ul class="first-ul second-panel-top">
          <li>只使用一台的情况下，大部分机器是很难超过75Mbps的，建议使用两台设备搭配使用或者考虑使用x86设备</li>
          <li>在 USB 2.0 接口上使用机械硬盘效果较差，晚高峰使用带宽最大不超过30Mbps，具体参考 <a href="https://bonuscloud.club/viewtopic.php?f=15&t=6778&p=29358#p29358">链接</a>的 Q3</li>
        </ul>
      </div>
      <div
        class="margin-20 bonus-tips"
        style="font-size: 14px;"
      >以下列举的参考带宽为单台数量，搭配固态硬盘</div>
      <el-collapse
        v-model="activeNames"
        @change="handleChange"
      >
        <el-collapse-item
          title="1.斐讯N1盒子"
          name="1"
        >
          <div class="bonus-tips ">适合上传带宽不大于75Mbps，推荐搭配固态硬盘</div>
          <div class="margin-top-10">最新版下载地址：<a
              class="bonus-color"
              href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/BonusCloud-LiteNode-N1-emmc.img.xz"
            >刷完激活即可，新手推荐</a></div>
          <div>安装教程：<a
              class="bonus-color"
              href="https://bonuscloud.club/viewtopic.php?f=48&t=690"
            >viewtopic.php?f=48&t=690</a></div>
          <div>刷机视频教程：<a
              class="bonus-color"
              href="https://bonuscloud.club/viewtopic.php?f=48&t=4571"
            >viewtopic.php?f=48&t=4571</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="2. 搭载S905L系列CPU的机顶盒等设备安装教程（ARMv8，64位）"
          name="2"
        >
          <div class="bonus-tips">适合上传带宽不大于50Mbps，推荐搭配固态硬盘</div>
          <div class="margin-top-10">R3300L：<a
              href="https://bonuscloud.club/viewtopic.php?f=53&amp;t=5766"
              class="bonus-color"
            >viewtopic.php?f=53&amp;t=5766</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="3.我家云/粒子矿云"
          name="3"
        >
          <div class="bonus-tips">适合上传带宽不大于50Mbps，推荐通过后部的 USB 3.0 接口接入固态硬盘</div>
          <div class="margin-top-10">最新版下载地址：<a
              href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/%E6%88%91%E5%AE%B6%E4%BA%91%E4%B8%80%E9%94%AE%E5%88%B7%E6%9C%BA%E5%8C%85%28%E5%90%AB%E9%A9%B1%E5%8A%A8%29%201.4.0.tar.xz"
              class="bonus-color"
            >刷完激活即可，新手推荐</a></div>
          <div>
            镜像安装教程：<a
              href="https://bonuscloud.club/viewtopic.php?f=51&amp;t=5877"
              class="bonus-color"
            >viewtopic.php?f=51&amp;t=5877</a></div>

          <div>简化版刷机教程：<a
              href="https://bonuscloud.club/viewtopic.php?f=54&amp;t=5891"
              class="bonus-color"
            >viewtopic.php?f=54&amp;t=5891</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="4.贝壳云"
          name="4"
        >
          <div class="bonus-tips">适合上传带宽不大于50Mbps</div>
          <div class="margin-top-10">贝壳云拆机刷机安装教程：<a
              href="https://bonuscloud.club/viewtopic.php?f=54&t=5896"
              class="bonus-color"
            >viewtopic.php?f=54&t=5896</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="5.Linux系统（Armbian，Debian等）脚本安装"
          name="5"
        >
          <div class="bonus-tips">注：脚本安装需要</div>
          <div class="bonus-tips margin-top-10">
            1.懂Linux操作，懂系统故障排除</br>
            2.有能够稳定访问Github的网络环境</br>
            3.对操作系统版本以及系统内核版本有要求</br>
          </div>
          <div class="margin-top-20">脚本安装教程-32位（ARMv7，32位）(注：仅支持A任务)：<a class="bonus-color" href="https://bonuscloud.club/viewtopic.php?f=51&t=3232">viewtopic.php?f=51&t=3232</a></br>
          脚本安装教程-64位（ARMv8，64位）：<a class="bonus-color" href="https://bonuscloud.club/viewtopic.php?f=51&t=3194">viewtopic.php?f=51&t=3194</a></br></div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div
      v-if="thirdPanel"
      class="first-panel"
    >
      <el-collapse
        v-model="activeNames"
        @change="handleChange"
      >
        <el-collapse-item
          title="1. 虚拟机安装文件下载"
          name="1"
        >
          <div class="margin-top-10"><a
              class="bonus-color"
              href="https://bonuscloud.club/viewtopic.php?f=52&t=5022"
            >viewtopic.php?f=52&t=5022</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="2. (推荐)PVE平台"
          name="2"
        >
          <div>
            最新版下载地址：<a href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/PVE-vzdump-qemu-180-2020_05_28-12_47_39.vma-%E7%BD%91%E7%BB%9C%E5%AE%89%E5%85%A8%E5%B7%A5%E7%A8%8B%E5%B8%88.lzo" class="bonus-color">刷完激活即可，新手推荐</a></br>
            教程：<a class="bonus-color" href="https://bonuscloud.club/viewtopic.php?f=52&t=5024">viewtopic.php?f=52&t=5024</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="3. (推荐)Hyper-V安装教程"
          name="3"
        >
          最新版下载地址：<a href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/Hyper-v-bxc-centos7-20200528-%E5%B0%81%E9%97%AD%E7%89%88-%E7%BD%91%E7%BB%9C%E5%AE%89%E5%85%A8%E5%B7%A5%E7%A8%8B%E5%B8%88.zip" class="bonus-color">刷完激活即可，新手推荐</a></br>
          教程：<a href="https://bonuscloud.club/viewtopic.php?f=52&t=5513" class="bonus-color">viewtopic.php?f=52&t=5513</a>
        </el-collapse-item>
        <el-collapse-item
          title="4. (推荐)ESXi安装教程 (安装后请务必自行修改强密码)"
          name="4"
        >
          <div>最新版下载地址：<a class="bonus-color" href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/ESXi-bxc-centos7-20200528-%E5%B0%81%E9%97%AD%E7%89%88-%E7%BD%91%E7%BB%9C%E5%AE%89%E5%85%A8%E5%B7%A5%E7%A8%8B%E5%B8%88.ova">刷完激活即可，新手推荐</a></br>
            教程及开放版下载地址 (安装后请务必自行修改强密码)：<a href="https://bonuscloud.club/viewtopic.php?f=52&t=13083" class="bonus-color">viewtopic.php?f=52&t=13083</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="5. (推荐)物理机镜像直装 推荐范围：核心或线程数小于等于12的机器"
          name="5"
        >
          <div>教程及开放版下载地址 (安装后请务必自行修改强密码)：<a href="https://bonuscloud.club/viewtopic.php?f=52&t=13122" class="bonus-color">viewtopic.php?f=52&t=13122</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="6. VirtualBox安装教程"
          name="6"
        >
          <div>最新版下载地址：<a href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/BonusCloud-LiteNode-x86.ova" class="bonus-color">刷完激活即可，新手推荐</a></br>
          教程：<a href="https://bonuscloud.club/viewtopic.php?f=52&t=5283" class="bonus-color">viewtopic.php?f=52&t=5283</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="7. VMware安装教程"
          name="7"
        >
          <div>最新版下载地址：<a href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/BonusCloud-LiteNode-x86.ova" class="bonus-color">刷完激活即可，新手推荐</a></br>
          教程：<a href="https://bonuscloud.club/viewtopic.php?f=52&t=5029" class="bonus-color">viewtopic.php?f=52&t=5029</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="8. x86群晖DSM系统安装教程"
          name="8"
        >
          <div>最新版下载地址：<a href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/BonusCloud-LiteNode-x86.ova" class="bonus-color">刷完激活即可，新手推荐</a></br>
            教程：<a href="https://bonuscloud.club/viewtopic.php?f=52&t=4960" class="bonus-color">viewtopic.php?f=52&t=4960</a></div>
        </el-collapse-item>
        <el-collapse-item
          title="9. 脚本完整安装计算任务教程"
          name="9"
        >
          <div><a href="https://bonuscloud.club/viewtopic.php?f=52&t=5230" class="bonus-color">viewtopic.php?f=52&t=5230</a></div>
          <div class="margin-top-20 bonus-tips" style="font-size: 14px">注：脚本安装需要</br>
            1.懂Linux操作，懂系统故障排除</br>
            2.有能够稳定访问Github的网络环境</br>
            3.对操作系统版本以及系统内核版本有要求</div>
        </el-collapse-item>
      </el-collapse>
      
    </div>
    <div v-if="fourthPanel" class="first-panel" style="font-size: 14px">
      请登录 <a href="https://console.bonuscloud.net/standardNode" class="bonus-color">标准节点提交</a> 页面查看详情
    </div>
    <div
      v-if="firstPanel || secondPanel || fourthPanel || thirdPanel"
      class="next-step guide-tab text-align-center margin-20"
      @click="nextStep"
    >上一步</div>

  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import Header from "@/WechatComponents/Header.vue";
import { getCookie } from "@/utils/utils";

export default {
  name: "home",
  components: {
    Header,
  },
  data() {
    return {
      email: "",
      unbindEmail: "",
      showUnbindDialog: false,
      firstPanel: false,
      secondPanel: false,
      thirdPanel: false,
      fourthPanel: false,
    };
  },
  computed: mapState({}),
  created() {},
  methods: {
    ...mapActions([]),
    nextStep() {
      this.firstPanel = false;
      this.secondPanel = false;
      this.thirdPanel = false;
      this.fourthPanel = false;
    },
  },
};
</script>

<style lang="stylus">

.guide-tab {
  width: 100%;
  padding: 8px 16px;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 4px;
  position: relative;
  background-color: #FFFFFF;
  overflow: hidden;
  opacity: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-transition: opacity 0.2s;
  transition: opacity 0.2s;
  margin: 20px auto;
  width: 80%;
  background-color: #f4f4f5;
  font-size: 13px;
  line-height: 18px;
}

.next-step{
  text-align center;
  margin: 20px;
  display: flex;
  justify-content: center;
  margin: 20px auto;
  width: 120px
  background: #0db4c5;
  color: #fff;
}

.guide-home.home.data-panel-home {
  // height: 100vh !important;
  background: #fff;
  position: relative;
}

.guide-content {
  background: #fff;
}

.guide-bottom {
  background: #fff;
  width: 100%;
  text-align: center;
  padding: 20px 20px;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 14px;
  margin-top: 50px;
}

.guide-detail-content {
  text-align: center;
  margin: 20px;
  font-size: bolder;
}

.guide-choose-type.el-alert {
  margin: 20px auto;
  width: 80%;
}

.first-panel {
  margin: 40px 40px 40px;
}

.guide-home .el-collapse {
  border: 0px;
}

.guide-home .el-collapse-item__content {
  margin: 10px;
}

.guide-home .el-collapse-item__header {
  line-height: 20px;
}

.second-ul {
  margin: 5px 15px;
}

.first-ul {
  margin: 5px 10px;
}

.second-panel-top li {
  margin-bottom: 10px;
  margin-top: 10px;
}

.second-panel-top {
  font-size: 14px;
  margin: 5px;
}
</style>

